import { Link, useRouter } from '@tanstack/react-router'
import { ArrowLeftIcon, FileQuestionIcon, HomeIcon } from 'lucide-react'
import { forwardRef } from 'react'

import { Button } from '@/components'
import type { StandardError } from '@/modules/errors'
import { BaseError } from './BaseError'

interface NotFoundProps extends React.HTMLAttributes<HTMLDivElement> {
  error?: StandardError
}

const NotFound = forwardRef<HTMLDivElement, NotFoundProps>(
  ({ error, ...props }, ref) => {
    const router = useRouter()

    return (
      <BaseError
        title="Not found"
        description={
          error?.message ||
          "The page you're looking for doesn't exist or has been moved."
        }
        icon={FileQuestionIcon}
        theme="info"
        {...props}
        ref={ref}
      >
        <Button onClick={() => router.history.back()} theme="outline">
          <ArrowLeftIcon className="h-4 w-4" />
          Go back
        </Button>
        <Button asChild>
          <Link to="/">
            <HomeIcon className="size-4" />
            Go home
          </Link>
        </Button>
      </BaseError>
    )
  },
)
NotFound.displayName = 'NotFound'

export { NotFound }
